import React, { Fragment, useMemo } from "react";

import { StyledTd, StyledTh, StyledTr } from "../../styled";
import Cell from "../Cell/Cell";
import { type ILandscapeRow } from "./landscape.types";
interface Props extends ILandscapeRow {
  rowIndex: number;
  sectionIndex: number;
  subSectionIndex: number;
}
const Row = ({
  items,
  name,
  rowIndex,
  sectionIndex,
  subSectionIndex,
}: Props) => {
  const rowSpan = useMemo(() => Object.keys(items).length, [items]);
  // let totalRows = 0;
  // Object.values(items).map(
  //   item => item && Object.keys(item.cols).length > 0 && totalRows++,
  // );
  return (
    <Fragment>
      {Object.keys(items).map((rowKey, idx) => {
        const item = items[rowKey];
        return (
          <StyledTr key={`row-${idx}`}>
            {idx === 0 && (
              <StyledTh
                rowSpan={rowSpan}
                width={item.width ? Number(item.width) * 10 : 150}>
                {name}
              </StyledTh>
            )}
            {!item.hidden && <StyledTh width={150}>{item.name}</StyledTh>}
            {Object.entries(item.cols).map(([key, col], idx) => {
              return (
                <StyledTd
                  key={`td-input-${key}`}
                  width={col.width ?? "100px"}
                  style={{ padding: 5 }}>
                  <Cell
                    {...(col as any)}
                    colIndex={idx}
                    uuid={key}
                    rowUuid={rowKey}
                    unitType={col.unit}
                    rowIndex={rowIndex}
                    flex={"row"}
                    label={col.name ?? ""}
                    dynamicRows={false}
                    sectionIndex={sectionIndex}
                    subSectionIndex={subSectionIndex}
                    history={false}
                    // totalRows={totalRows}
                  />
                </StyledTd>
              );
            })}
          </StyledTr>
        );
      })}
    </Fragment>
  );
};
export default React.memo(Row);
